import { generateMeasuresFromDimensions } from './generate-measures.js';
import { meetingBodyLink } from './links.js';
import { meetingStatusValueLabels, minutesStatusValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'meetings.duration_minutes': {
        aggregations: ['avg'],
        label: 'Duration (Minutes)',
        type: 'number',
    },
};
/** Scheduled sessions of a meeting body where legislative business is conducted. */
export const meetingsCube = {
    category: 'Meetings',
    description: 'Meeting sessions with schedule, status, agenda summary, and recording availability.',
    label: 'Meetings',
    question: 'When does each meeting happen and which artifacts are ready?',
    bestFor: 'One row per scheduled meeting — the master schedule with status, duration, and whether the agenda, minutes, and video have been published.',
    tags: ['Schedule', 'Status', 'Recordings'],
    measures: {
        'meetings.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
        'meetings.sum_agenda_item_count': { label: 'Total Agenda Items', type: 'number' },
        'meetings.distinct_location': { label: 'Distinct Locations', type: 'number' },
    },
    dimensions: {
        ...aggregatableDimensions,
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
        'meetings.agenda_item_count': { label: 'Agenda Item Count', type: 'number' },
        'meetings.has_agenda': { label: 'Has Agenda', type: 'boolean' },
        'meetings.has_minutes': { label: 'Has Minutes', type: 'boolean' },
        'meetings.has_video': { label: 'Has Video', type: 'boolean' },
        'meetings.is_cancelled': { label: 'Is Cancelled', type: 'boolean' },
        'meetings.is_private': { label: 'Is Private', type: 'boolean' },
        'meetings.location': { label: 'Location', type: 'string' },
        'meetings.minutes_status': {
            label: 'Minutes Status',
            type: 'string',
            valueLabels: minutesStatusValueLabels,
        },
        'meetings.status': { label: 'Status', type: 'string', valueLabels: meetingStatusValueLabels },
        'meetings.title': { label: 'Title', type: 'string' },
    },
    timeDimensions: {
        'meetings.agenda_published_at': { label: 'Agenda Published At', type: 'date' },
        'meetings.completed_at': { label: 'Completed At', type: 'date' },
        'meetings.created_at': { label: 'Created At', type: 'date' },
        'meetings.date': { label: 'Meeting Date', type: 'date' },
        'meetings.started_at': { label: 'Started At', type: 'date' },
    },
};
